var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "add-type-modal",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.show,
        title: "",
        width: "480px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _c(
        "el-form",
        {
          ref: "formType",
          staticClass: "type-body",
          attrs: {
            model: _vm.params,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.label, prop: "value" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "" + _vm.holderText,
                  type: "text",
                  maxlength: "20",
                },
                model: {
                  value: _vm.params.value,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.params,
                      "value",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "params.value",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.onChange } },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.onSave },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }